module.exports = __webpack_public_path__ + "assets/blog2.ff8d0e52.jpg";